import {
  VuexModule,
  Module,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
import { OffersCommonLight, IOrderContent } from "@smeetz/offers-common";
import { IOffersState } from "@/interfaces/store/IOffers";
import { IOfferApplication } from "@smeetz/offers-common";
@Module({ dynamic: true, namespaced: true, store, name: "Offers" })
class Offers extends VuexModule implements IOffersState {
  public offersCommon: OffersCommonLight | null = null;
  public appliedOffers: Record<string, IOfferApplication[]> = {};

  @Mutation
  setOffersCommon(data: { offersCommon: OffersCommonLight }) {
    const { offersCommon } = data;
    this.offersCommon = offersCommon;
  }

  @Mutation
  setAppliedOffers(data: {
    bookingUuid: string;
    offerApplications: IOfferApplication[];
  }) {
    const { bookingUuid, offerApplications } = data;
    this.appliedOffers[bookingUuid] = offerApplications;
  }

  @Mutation
  confirmAppliedOffers(data: {
    bookingUuid: string;
    offerApplicationsUuids: string[];
  }) {
    console.log("hi from confirmAppliedOffers", data);
    const { bookingUuid, offerApplicationsUuids } = data;

    // For each offerApplicationUuid, we need to find the corresponding offerApplication and then assign it isConfirmedOnBackend to true
    for (const offerApplicationUuid of offerApplicationsUuids) {
      const offerApplications = this.appliedOffers[bookingUuid];
      if (offerApplications) {
        const offerApplication = offerApplications.find(
          (oa) => oa.applicationUuid === offerApplicationUuid
        );
        if (offerApplication) {
          offerApplication.isOfferConfirmedOnBackend = true;
        }
      }
    }
  }

  @Mutation
  clearBookingOffers(bookingUuid: string) {
    if (this.appliedOffers[bookingUuid]) {
      this.appliedOffers[bookingUuid] = [];
    }
  }

  @Mutation
  deleteBookingOffersTracking(bookingUuid: string) {
    if (this.appliedOffers[bookingUuid]) {
      delete this.appliedOffers[bookingUuid];
    }
  }
  /**
   * Resotres offers module fields saved in localstorage
   */
  @Mutation
  restore(offersFields: Partial<IOffersState>) {
    const { appliedOffers } = offersFields;
    if (appliedOffers) {
      this.appliedOffers = appliedOffers;
    }
  }
}

const OffersModule = getModule(Offers);
export default OffersModule;
